import * as moment from 'moment';

let yearRatesCache: Map<number, number> = new Map();

export const seedMileageRates = (rates: Array<{ year?: number; rate?: number; Year?: number; Rate?: number }> | null | undefined): void => {
    if (!rates || !Array.isArray(rates) || rates.length === 0) {
        return;
    }
    const next = new Map<number, number>();
    rates.forEach((entry) => {
        const year = entry?.year ?? (entry as any)?.Year;
        const rate = entry?.rate ?? (entry as any)?.Rate;
        if (typeof year === 'number' && typeof rate === 'number') {
            next.set(year, rate);
        }
    });
    if (next.size > 0) {
        yearRatesCache = next;
    }
};

export const getMileageRateForDate = (date?: Date): number => {
    const d = date ?? new Date();
    const year = moment(d).year();
    if (yearRatesCache.has(year)) {
        return yearRatesCache.get(year) as number;
    }
    if (yearRatesCache.size > 0) {
        const latestYear = Math.max(...Array.from(yearRatesCache.keys()));
        return yearRatesCache.get(latestYear) as number;
    }
    return 0;
};

export const resolveMileageRate = (
    persistedRate?: number | null,
    tripDate?: Date | string | null
): number => {
    if (persistedRate != null && persistedRate > 0) {
        return persistedRate;
    }
    const date = tripDate
        ? (tripDate instanceof Date ? tripDate : new Date(tripDate as any))
        : undefined;
    return getMileageRateForDate(date);
};

export const yearRates = (createdDateTime: Date) => {
    const map = new Map<number, number>();
    yearRatesCache.forEach((rate, year) => map.set(year, rate));
    if (map.size === 0) {
        map.set(moment(createdDateTime).year(), getMileageRateForDate(createdDateTime));
    }
    return map;
};
